export default __webpack_public_path__ + "static/media/899.332bf7d7.png";